var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08464 15.8332H6.66797C3.33464 15.8332 1.66797 14.9998 1.66797 10.8332V6.6665C1.66797 3.33317 3.33464 1.6665 6.66797 1.6665H13.3346C16.668 1.6665 18.3346 3.33317 18.3346 6.6665V10.8332C18.3346 14.1665 16.668 15.8332 13.3346 15.8332H12.918C12.6596 15.8332 12.4096 15.9582 12.2513 16.1665L11.0013 17.8332C10.4513 18.5665 9.5513 18.5665 9.0013 17.8332L7.7513 16.1665C7.61797 15.9832 7.30964 15.8332 7.08464 15.8332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 6.6665H14.1654",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 10.8335H10.832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoMessage);
export default __webpack_public_path__ + "static/media/trvto_message.8e0a22296d6d09ce98117409b89215a5.svg";
export { ForwardRef as ReactComponent };